import {
  IElectricVehicleUsage,
  ISolarPanelConfiguration,
  IUsageAdjustment,
  IUsageProfile,
  IUsageEstimation,
} from "./types"

const getEvOutput = (electricVehicles: IElectricVehicleUsage[]) =>
  electricVehicles.reduce((totalUsage, { vehicle, milesPerYear }) => {
    if (!vehicle) return totalUsage

    const cycles = milesPerYear / vehicle.range
    const vehicleUsage = Math.round(cycles * vehicle.batteryCapacity)
    return totalUsage + vehicleUsage
  }, 0)

const getSolarOutput = ({ panel, panelCount }: ISolarPanelConfiguration) =>
  panel?.annualOutput ? Math.round(panelCount * panel.annualOutput) : 0

const getUsageForProfile = (
  usageProfile: IUsageProfile,
  usageDetails: IUsageAdjustment,
): Partial<IUsageEstimation> => {
  const evOutput = usageDetails.electricVehicles
    ? getEvOutput(usageDetails.electricVehicles)
    : 0

  const solarOutput = usageDetails.solarPanelConfiguration
    ? getSolarOutput(usageDetails.solarPanelConfiguration)
    : 0

  if (usageDetails.dayNightUsageRatio !== undefined) {
    return {
      electricityDay: Math.round(
        (usageProfile.electricityTwoRateUsage *
          usageDetails.dayNightUsageRatio) /
          100 -
          solarOutput,
      ),
      electricityNight: Math.round(
        (usageProfile.electricityTwoRateUsage *
          (100 - usageDetails.dayNightUsageRatio)) /
          100 +
          evOutput,
      ),
      electricity:
        usageProfile.electricityTwoRateUsage - solarOutput + evOutput,
      gas: usageProfile.gasUsage,
    }
  } else {
    return {
      electricity: usageProfile.electricityUsage - solarOutput + evOutput,
      gas: usageProfile.gasUsage,
    }
  }
}

export default getUsageForProfile
